<template>
   <div>
     <div class="carregando-show" v-if="carregando">
        <Loading size="medium"></Loading>
     </div>
     <div class="erro-carregando" v-if="!carregando && erro">
        <ErroResultados></ErroResultados>
     </div>
     <template v-if="!carregando && !erro">
        <ExibirAtoInfralegal :ato-infralegal="atoInfralegal" />
        <DownloadPdf 
          :url="urlPdf" 
          :evento="'visualizacao_pdf_infralegal'" 
          :categoria="'download_pdf_infralegal'" 
          :label="labelAtoInfralegal" 
        />
     </template>
   </div>
</template>

<script>
import slugify from "slugify";

import AtoInfralegalApi from "../../services/AtoInfralegalApi";
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import ExibirAtoInfralegal from "../../components/pesquisa_ato_infralegal/ExibirAtoInfralegal";
import titleAtoInfralegal from "../../helpers/atoInfralegal/titleAtoInfralegal";
import metaDados from "../../helpers/metaDados";
import DownloadPdf from "../../components/DownloadPdf";

const truncate = require("lodash.truncate");

export default {
   name: "PesquisaAtoInfralegalShow",
   metaInfo() {
     if (!this.atoInfralegal) {
        return {};
     }

     let title = titleAtoInfralegal(this.atoInfralegal);
     const description = truncate(this.atoInfralegal.conteudo, {length: 160});

     return {
        title,
        titleTemplate: "%s - Casa Civil do Estado de Goiás",
        meta: [
          {
             vmid: "description",
             name: "description",
             property: "description",
             content: description,
          },
          {
             vmid: "og:description",
             property: "og:description",
             content: description,
          },
          {
             vmid: "og:title",
             property: "og:title",
             content: `${title} - Casa Civil do Estado de Goiás`,
          },
          {
             vmid: "twitter:description",
             name: "twitter:description",
             property: "twitter:description",
             content: description,
          },
          {
             vmid: "twitter:title",
             name: "twitter:title",
             property: "twitter:title",
             content: `${title} - Casa Civil do Estado de Goiás`,
          },
          ...metaDados(this.$route),
        ],
     };
   },
   data() {
     return {
        carregando: true,
        erro: false,
        atoInfralegal: null,
        urlPdf: null,
        labelAtoInfralegal: '',
     };
   },
   components: {
     Loading,
     ErroResultados,
     ExibirAtoInfralegal,
     DownloadPdf
   },
   created() {
     this.atoInfralegalApi = new AtoInfralegalApi();

     this.carregarAtoInfralegal();
   },
   watch: {
     $route: function(to, from) {
        if (to.params.id != from.params.id) {
          this.carregarAtoInfralegal();
        }
     },
   },
   methods:{
     carregarAtoInfralegal: async function() {
        try {
          this.carregando = true;
          this.erro = false;

          if (this.atoInfralegalApi.cancelTokens.getAtoInfralegal) {
             this.atoInfralegalApi.cancelTokens.getAtoInfralegal.cancel();
          }

          this.atoInfralegal = await this.atoInfralegalApi.getAtoInfralegal(
             this.$route.params.id
          );

          this.urlPdf = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/atos_infralegais/${this.atoInfralegal.id}/pdf`;
                    if (this.atoInfralegal && this.atoInfralegal.tipo_ato_infralegal.nome) {
                       this.labelAtoInfralegal = `${this.atoInfralegal.tipo_ato_infralegal.nome} Nº ${this.atoInfralegal.numero} / ${this.atoInfralegal.ano}`;
                    }
                    const generatedSlug = this.createSlug();
                    const generatedOrgaoSlug = this.createOrgaoSlug(); 
                    const currentOrgaoSlug = this.$route.params.orgaoSlug;
                    const currentSlug = this.$route.params.slug;
                    let shouldRedirect = false;
                    let newParams = { ...this.$route.params };

                    // If orgaoSlug is missing from the URL but we have a generated one
                    if (!currentOrgaoSlug && generatedOrgaoSlug) {
                      shouldRedirect = true;
                      newParams.orgaoSlug = generatedOrgaoSlug;
                    } 

                    // If orgaoSlug is present but incorrect
                    else if (currentOrgaoSlug && generatedOrgaoSlug && currentOrgaoSlug !== generatedOrgaoSlug) {
                      shouldRedirect = true;
                      newParams.orgaoSlug = generatedOrgaoSlug;
                    }

                    // If slug is missing from the URL but we have a generated one
                    if (!currentSlug && generatedSlug) {
                      shouldRedirect = true;
                      newParams.slug = generatedSlug;
                    }

                    // If slug is present but incorrect
                    else if (currentSlug && generatedSlug && currentSlug !== generatedSlug) {
                      shouldRedirect = true;
                      newParams.slug = generatedSlug;
                    }

                    if (shouldRedirect) {
                       this.$router.replace({
                         name: "PesquisaAtoInfralegalShow", // Always redirect to the canonical named route
                         params: newParams,
                         query: this.$route.query,
                       });
                    }
          
                    this.carregando = false;
        } catch (err) {
          if (this.atoInfralegalApi.isCancel(err)) {
             return;
          }
          console.log(err); // Mantido para erros não cancelados

          this.erro = true;
          this.carregando = false;
          this.atoInfralegal = null;
        }
     },
     createSlug: function() {
        let tipoAtoInfralegal = "";
        if (
          this.atoInfralegal &&
          this.atoInfralegal.tipo_ato_infralegal &&
          this.atoInfralegal.tipo_ato_infralegal.nome
        ) {
          tipoAtoInfralegal = this.atoInfralegal.tipo_ato_infralegal.nome
             .toLowerCase()
             .replace(/ordinária|numerado/, "")
             .trim();
        }
        if (this.atoInfralegal && tipoAtoInfralegal) {
          const slug = `${tipoAtoInfralegal} ${this.atoInfralegal.numero}`;
          return slugify(slug, {
             lower: true,
             strict: true,
             locale: "pt",
          });
        }
        return undefined;
     },
     createOrgaoSlug: function() {
        if (this.atoInfralegal && this.atoInfralegal.orgao_relacionado_sigla) {
          return slugify(this.atoInfralegal.orgao_relacionado_sigla, {
             lower: true,
             strict: true,
             locale: "pt",
          });
        }
        else if (
          this.atoInfralegal &&
          this.atoInfralegal.orgaos &&
          this.atoInfralegal.orgaos.length > 0 &&
          this.atoInfralegal.orgaos[0].nome
        ) {
          return slugify(this.atoInfralegal.orgaos[0].nome, {
             lower: true,
             strict: true,
             locale: "pt",
          });
        }
        return undefined;
     },
   }
}
</script>
<style lang="scss" scoped>
.carregando-show {
   display: flex;
   flex: 1;
   flex-direction: row;
   align-items: center;
   justify-content: center;
   height: 100vh;
}
.erro-carregando {
   display: flex;
   flex: 1;
   flex-direction: row;
   align-items: center;
   justify-content: center;
   height: 100vh;
}
</style>